import { useMutation, useQueryClient } from 'react-query'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { buildErrorMessage } from 'utils'
import { ChatClient } from 'api/clients/ChatClient'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { chatKeys } from './chatKeys'
import { reportError } from 'utils/error'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'

export interface Variables {
  messageId: number
  threadId: number
  rating: number | 'upvote' | 'downvote'
  issueType?: string
  comment?: string
}

export const rateMessage = async (variables: Variables) => {
  const { messageId, rating, issueType, comment } = variables
  const response = await ChatClient.rateMessage(messageId, rating, {
    ...(issueType && { issueType }),
    ...(comment && { comment }),
  })

  if (response.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(
      buildErrorMessage(response.data.errors) ||
        'An error occurred! Our team has been notified and we are looking into it.',
    )
  }
  return response.data
}

export const useRateMessage = () => {
  const workspaceId = useCurrentWorkspaceId()
  const queryClient = useQueryClient()

  return useMutation<void, unknown, Variables>(
    'rateMessage',
    async (variables) => {
      return rateMessage(variables)
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries(chatKeys.threadMessages(workspaceId, variables.threadId))
        showToastMessage('Thanks for your feedback!', 'success')
      },
      onError: (err) => {
        reportError(err, {
          severity: 'error',
        })
      },
    },
  )
}
